import { render, staticRenderFns } from "./UnitDetailDialog.vue?vue&type=template&id=52ffe848"
import script from "./UnitDetailDialog.vue?vue&type=script&lang=js"
export * from "./UnitDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports